import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"

export interface BankAccount {
  id: string
  name: string
  bankName: string
  type: string
  last4: string
  owner: string
  isActive?: boolean
  transactionCount: number
  /** Newest transaction date on the account ("YYYY-MM-DD"), null if none. */
  latestTransactionDate?: string | null
  /** Period the last statement import covered, null if never imported from a statement. */
  lastImportFrom?: string | null
  lastImportTo?: string | null
  /** Days since the last statement ended; set only when an active account is behind. */
  statementGapDays?: number | null
}

/** GET /accounts — same query key the settings tab and upload dialog use. */
export function useAccounts(opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["accounts"],
    queryFn: () => api.get<{ success: boolean; data: BankAccount[] }>("/accounts"),
    enabled: opts.enabled ?? true,
  })
}
